<template>
  <div v-if="totalPages > 1" class="flex justify-center items-center gap-1 sm:gap-2 py-3 select-none">
    <button 
      @click="$emit('update:modelValue', currentPage - 1)" 
      :disabled="currentPage <= 1"
      class="inline-flex items-center justify-center h-9 px-3 rounded-lg text-xs sm:text-sm font-medium
             text-slate-600 bg-white ring-1 ring-slate-200 shadow-sm
             hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30
             disabled:opacity-50 disabled:cursor-not-allowed active:translate-y-[1px]">
      Previous
    </button>
    
    <button 
      v-for="page in visiblePages" 
      :key="page"
      @click="$emit('update:modelValue', page)"
      :class="[
        'inline-flex items-center justify-center h-9 min-w-9 px-3 rounded-lg text-xs sm:text-sm font-medium transition-all',
        page === currentPage 
          ? 'bg-gradient-to-r from-[#00cdac] to-[#62EC14] text-white shadow-md ring-1 ring-black/5' 
          : 'text-slate-700 bg-white ring-1 ring-slate-200 hover:bg-slate-50 hover:text-[#00cdac]'
      ]">
      {{ page }}
    </button>
    
    <button 
      @click="$emit('update:modelValue', currentPage + 1)" 
      :disabled="currentPage >= totalPages"
      class="inline-flex items-center justify-center h-9 px-3 rounded-lg text-xs sm:text-sm font-medium
             text-slate-600 bg-white ring-1 ring-slate-200 shadow-sm
             hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30
             disabled:opacity-50 disabled:cursor-not-allowed active:translate-y-[1px]">
      Next
    </button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    modelValue: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      required: true
    },
    maxVisible: {
      type: Number,
      default: 5
    }
  },
  emits: ['update:modelValue'],
  computed: {
    currentPage: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = Math.floor(this.maxVisible / 2);
      
      let start = Math.max(1, current - delta);
      let end = Math.min(total, current + delta);
      
      if (end - start < this.maxVisible - 1) {
        if (start === 1) {
          end = Math.min(total, start + this.maxVisible - 1);
        } else {
          start = Math.max(1, end - this.maxVisible + 1);
        }
      }
      
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      
      return pages;
    }
  }
}
</script>

